/** Inline SVG icons — no icon-library dep. Each accepts className for sizing. */
import type { SVGProps } from 'react';

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        d="M16.7 5.3a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0L3.3 10.7a1 1 0 1 1 1.4-1.4l3.1 3.1 6.8-6.8a1 1 0 0 1 1.4 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function AlertIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        d="M8.5 3.1a1.8 1.8 0 0 1 3 0l5.6 9.5A1.8 1.8 0 0 1 15.5 16h-11a1.8 1.8 0 0 1-1.6-3.4L8.5 3.1ZM10 7a.8.8 0 0 1 .8.8v3.4a.8.8 0 1 1-1.6 0V7.8A.8.8 0 0 1 10 7Zm0 6.4a1 .9 0 1 0 0 1.8 1 .9 0 0 0 0-1.8Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function SpinnerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className="animate-spin"
      {...props}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function LinkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <path
        d="M7 13l6-6M8 7h-.5A3.5 3.5 0 0 0 4.5 13a3.5 3.5 0 0 0 3.5 0M12 7h.5A3.5 3.5 0 0 1 13 13a3.5 3.5 0 0 1-3.5 0"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
